import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [theme, setTheme] = useState(null);

    useEffect(() => {
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            setTheme("dark");
        } else {
            setTheme("light");
        }
    }, []);

    useEffect(() => {
        if (theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [theme]);

    const handleThemeSwitch = () => {
        setTheme(theme === "dark" ? "light" : "dark");
    };

    return (
        <div className="sticky top-0 bg-slate-50 dark:bg-slate-900 z-20 px-3 md:px-8 ">
            <nav className="px-2 py-2.5">
                <div className="flex flex-wrap justify-between items-center mx-auto">
                    <Link
                        to="/"
                        className="text-xl md:text-[20px] dark:text-[#E9F8F9] font-semibold lg:text-2xl"
                    >
                        Nabil.
                    </Link>
                    <button
                        onClick={() => setOpen(!open)}
                        data-collapse-toggle="navbar-sticky"
                        type="button"
                        className="inline-flex items-center p-2 ml-3 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none"
                        aria-controls="navbar-sticky"
                        aria-expanded="true"
                    >
                        <span className="sr-only">Open main menu</span>
                        <svg
                            className="w-5 h-5"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </button>
                    <div
                        className={
                            open
                                ? "w-full md:block lg:w-auto"
                                : "hidden md:block md:w-auto"
                        }
                        id="navbar-sticky"
                    >
                        <ul className="flex flex-col text-gray-500 dark:text-[#E9F8F9] md:py-2 text-[14px] lg:text-sm mt-4 md:flex-row md:space-x-8 md:mt-0 xl:text-lg md:font-medium">
                            <li className="pb-3 md:pb-0">
                                <NavLink
                                    to="/home"
                                    className="hover:text-[#98A8F8]"
                                    line-through
                                >
                                    Home
                                </NavLink>
                            </li>
                            <li className="pb-3 md:pb-0">
                                <NavLink
                                    to="/skills"
                                    className="hover:text-[#98A8F8] "
                                    
                                >
                                    Skills
                                </NavLink>
                            </li>
                            <li className=" pb-3 md:pb-0">
                                <NavLink
                                    to="/projects"
                                    className="hover:text-[#98A8F8]"
                                >
                                    Projects
                                </NavLink>
                            </li>
                            <li className=" pb-3 md:pb-0">
                                <NavLink
                                    to="/about"
                                    className="hover:text-[#98A8F8]"
                                >
                                    About
                                </NavLink>
                            </li>
                            <li className=" pb-3 md:pb-0">
                                <NavLink
                                    to="/contact"
                                    className="hover:text-[#98A8F8]"
                                >
                                    Contact
                                </NavLink>
                            </li>
                            {/* <ThemeChange/> */}
                            {/* <li className=" pb-3 md:pb-0">
                                <a
                                    href="https://drive.google.com/file/d/1mml-5tbGmERS65eaqPaRmj8-_e1sMJl1/view?usp=share_link"
                                    className="hover:text-[#f26b38]"
                                >
                                    Download Resume
                                </a>
                            </li> */}
                            {/* <BiMoon /> */}
                            {/* <ThemeChange /> */}
                            <button
                                type="button"
                                onClick={handleThemeSwitch}
                                // className="bg-indigo-500 text-lg p-1 rounded-md"
                            >
                                {theme === "dark" ? "🌞" : "🌙"}
                            </button>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
